import { useQuery } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import {
  IonButton,
  IonCol,
  IonInput,
  IonLabel,
  IonRow,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";

//
import { Breadcrumbs } from "../../../components";

//
import { GET_MY_AGENCY } from "../../../graphql/queries/common.query";
import { GET_PACKAGE_PRICE_BY_SERVICE_TYPE } from "../../../graphql/queries/price.query";
import { isAuthenticated } from "../../../lib/utils/auth.utils";

//

//
const breadcrumbEntries = [{ title: "Passaggio proprietà - Pratiche auto" }];

//
export default function OwnershipTransferSpecialPricing() {
  const [price, setPrice] = useState<number>(0);
  const [price2, setPrice2] = useState<number>(0);
  const [isCalculated, setIsCalculated] = useState<boolean>(false);
  const [isCalculated2, setIsCalculated2] = useState<boolean>(false);

  //
  const [agencyDetails, setAgencyDetails] = useState<any>();

  //
  const [mopedPrice, setMopedPrice] = useState<any>(null);
  const [vehiclePrice, setVehiclePrice] = useState<any>(null);
  const [motorVehiclePrice, setMotorVehiclePrice] = useState<any>(null);

  //
  const [optionValue, setOptionValue] = useState<SelectOptionValues | null>(
    null
  );

  const [kg, setKg] = useState<number | null>(null);
  const [kwatt, setKwatt] = useState<number | null>(null);

  if (isAuthenticated()) {
    useQuery(GET_MY_AGENCY, {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        setAgencyDetails(data.getMyAgency);
      },
    });
  }

  //
  useQuery(GET_PACKAGE_PRICE_BY_SERVICE_TYPE, {
    onCompleted(data) {
      const actualData = data.getPackagePriceBasedOnType?.data;
      if (!actualData) return;

      //
      setMopedPrice(actualData);
    },
    variables: { type: "mopedOwnershipTransfer" },
  });

  //
  useQuery(GET_PACKAGE_PRICE_BY_SERVICE_TYPE, {
    onCompleted(data) {
      const actualData = data.getPackagePriceBasedOnType?.data;
      if (!actualData) return;

      //
      setVehiclePrice(actualData);
    },
    variables: { type: "vehicleOwnershipTransfer" },
  });

  //
  useQuery(GET_PACKAGE_PRICE_BY_SERVICE_TYPE, {
    onCompleted(data) {
      const actualData = data.getPackagePriceBasedOnType?.data;
      if (!actualData) return;

      //
      setMotorVehiclePrice(actualData);
    },
    variables: { type: "motorVehicleOwnershipTransfer" },
  });

  //
  const priceDescription = useMemo(() => {
    if (mopedPrice?.serviceItem?.description) {
      return mopedPrice.serviceItem.description;
    }

    if (vehiclePrice?.serviceItem?.description) {
      return vehiclePrice.serviceItem.description;
    }

    if (motorVehiclePrice?.serviceItem?.description) {
      return motorVehiclePrice.serviceItem.description;
    }

    return "";
  }, [mopedPrice, vehiclePrice, motorVehiclePrice]);

  //
  const calculatePrice = () => {
    const priceValues = motorVehiclePrice?.packagePrice ?? [];

    const sitePrice = priceValues.find((price: any) =>
      price.range
        ? +(kwatt ?? 0) >= price.range?.min && +(kwatt ?? 0) <= price.range?.max
        : kwatt?.toString() === price.category
    );

    if (!sitePrice) return;

    //
    const discountType = agencyDetails?.client?.discount;

    //
    if (discountType === "premium") {
      setPrice(sitePrice.premiumPrice);
    } else if (discountType === "gold") {
      setPrice(sitePrice.goldPrice);
    } else {
      setPrice(sitePrice.basicPrice);
    }

    //
    setIsCalculated(true);
  };

  //
  const calculatePrice2 = () => {
    let priceItem: any = null;
    let priceValues: any[] = [];

    //
    if (optionValue === "moped") {
      priceValues = mopedPrice?.packagePrice ?? [];
      priceItem = priceValues[0];
    }

    //
    if (optionValue === "vintage") {
      priceValues = motorVehiclePrice?.packagePrice ?? [];
      priceItem = priceValues.find((item: any) => item.tab === "Auto d’epoca");
    }

    //
    if (optionValue === "motorVehicle") {
      priceValues = vehiclePrice?.packagePrice ?? [];
      priceItem = priceValues[0];
    }

    //
    if (optionValue === "truck") {
      priceValues = motorVehiclePrice?.packagePrice ?? [];
      priceItem = priceValues.find(
        (price: any) =>
          price.tab === "kg" &&
          kg &&
          kg >= price.range?.min &&
          kg <= price.range?.max
      );
    }

    //
    if (!priceItem) return;

    //
    const discountType = agencyDetails?.client?.discount;

    //
    if (discountType === "premium") {
      setPrice2(priceItem.premiumPrice);
    } else if (discountType === "gold") {
      setPrice2(priceItem.goldPrice);
    } else {
      setPrice2(priceItem.basicPrice);
    }

    //
    setIsCalculated2(true);
  };

  //
  const isSecondCalculateDisabled = useMemo(() => {
    if (!optionValue) return true;
    if (optionValue === "truck" && !kg) return true;

    return false;
  }, [optionValue, kg]);

  //
  useEffect(() => {
    setPrice(0);
    setIsCalculated(false);
  }, [kwatt]);

  //
  useEffect(() => {
    setPrice2(0);
    setIsCalculated2(false);
  }, [optionValue]);

  //
  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} backButton />

      <div className="order-page-wrapper order-page-wrapper-details">
        <IonRow className="height-full">
          <IonCol
            sizeSm="12"
            sizeMd="12"
            sizeLg="5"
            sizeXs="12"
            className="order-input-section"
          >
            <h1 className="details-title">Passaggio proprietà</h1>

            <hr />

            <div>
              <div>
                <div className="details-option">
                  <IonLabel>Inserire I Kilowatts del veicolo</IonLabel>
                  <IonInput
                    min="1"
                    type="number"
                    value={kwatt}
                    className="detail-selector"
                    onIonChange={(e) =>
                      setKwatt(parseInt(e.detail.value ?? "0"))
                    }
                  />
                </div>

                <div className="details-option">
                  <IonButton
                    disabled={!kwatt}
                    expand="full"
                    shape="round"
                    className="details-button"
                    onClick={calculatePrice}
                  >
                    Calcola
                  </IonButton>
                </div>

                {isCalculated && (
                  <div className="price-group">
                    <span className="price-group-label">da</span>
                    <div className="price-item">
                      <strong>€ {price}</strong>
                    </div>
                  </div>
                )}
              </div>

              <hr style={{ marginTop: "2rem" }} />

              <div>
                <div className="details-option">
                  <IonLabel>Non è un auto</IonLabel>

                  <IonSelect
                    value={optionValue}
                    onIonChange={(e) => {
                      setOptionValue(e.detail.value);
                    }}
                    interface="alert"
                    className="detail-selector"
                  >
                    <IonSelectOption value="moped" defaultChecked>
                      Ciclomotore
                    </IonSelectOption>
                    <IonSelectOption value="vintage">
                      auto d’epoca
                    </IonSelectOption>
                    <IonSelectOption value="truck">autocarro</IonSelectOption>
                    <IonSelectOption value="motorVehicle">
                      motociclo
                    </IonSelectOption>
                  </IonSelect>
                </div>

                {optionValue === "truck" && (
                  <div className="details-option">
                    <IonLabel>Inserire la capacità in kg</IonLabel>
                    <IonInput
                      min="1"
                      type="number"
                      inputMode="numeric"
                      value={kg}
                      placeholder="Inserisci valore"
                      className="detail-selector"
                      onIonChange={(e) =>
                        setKg(parseInt(e.detail.value ?? "0"))
                      }
                    />
                  </div>
                )}

                <div className="details-option">
                  <IonButton
                    expand="full"
                    shape="round"
                    className="details-button"
                    onClick={calculatePrice2}
                    disabled={isSecondCalculateDisabled}
                  >
                    Calcola
                  </IonButton>
                </div>

                {isCalculated2 && (
                  <div className="price-group">
                    <span className="price-group-label">da</span>
                    <div className="price-item">
                      <strong>€ {price2}</strong>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </IonCol>
          <IonCol
            sizeSm="12"
            offset-lg="1"
            sizeMd="12"
            sizeLg="6"
            sizeXs="12"
            className="order-extra-details"
          >
            <div className="order-extra-container">
              {priceDescription && <p>{priceDescription}</p>}

              <div>
                <h4>
                  <strong>
                    Per fare questa pratica devi venirci a trovare
                  </strong>
                </h4>
              </div>

              <div className="order-extra-details-item">
                <IonButton
                  expand="full"
                  shape="round"
                  className="details-button"
                  href="https://www.cosmilano.it/prenota-un-appuntamento/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Prenota appuntamento
                </IonButton>
              </div>
            </div>
          </IonCol>
        </IonRow>
      </div>
    </div>
  );
}

//
type SelectOptionValues = "moped" | "vintage" | "truck" | "motorVehicle";
